(() => {
  const prepare = root => {
    root.querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || link.hasAttribute('download') ||
          link.matches('[role="button"],[aria-controls],.skip-to-content-link,#cart-icon-bubble') ||
          link.closest('cart-drawer,cart-notification')) return;
      let url;
      try { url = new URL(href, location.href); } catch { return; }
      if (!['http:', 'https:'].includes(url.protocol)) return;
      if (url.origin === location.origin) {
        if (link.target === '_blank') link.removeAttribute('target');
        link.relList.remove('noreferrer');
      } else {
        link.target = '_blank';
        link.relList.add('noopener', 'noreferrer');
      }
    });
  };
  prepare(document);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType !== 1) continue;
      prepare(node.matches('a[href]') ? node.parentElement : node);
    }
  }).observe(document.documentElement, {childList: true, subtree: true});
})();
